import { useEffect, useState } from "react";
import { WifiOff } from "lucide-react";

export default function OfflineBanner() {
  const [off, setOff] = useState(() => typeof navigator !== "undefined" && !navigator.onLine);
  useEffect(() => {
    const goOn = () => setOff(false);
    const goOff = () => setOff(true);
    window.addEventListener("online", goOn);
    window.addEventListener("offline", goOff);
    return () => {
      window.removeEventListener("online", goOn);
      window.removeEventListener("offline", goOff);
    };
  }, []);
  if (!off) return null;
  return (
    <div
      data-testid="offline-banner"
      className="no-print fixed bottom-4 left-1/2 -translate-x-1/2 z-[9999] flex items-center gap-2 rounded-full px-4 py-2 text-[12px] font-bold shadow-xl"
      style={{ background: "#0e1a2e", color: "#6B8F71", border: "1px solid rgba(107,143,113,0.4)" }}
    >
      <WifiOff className="h-3.5 w-3.5 shrink-0" />
      Offline study mode — showing saved content
    </div>
  );
}
